import ReactGA from 'react-ga';

export class AnalyticsStore {
  constructor(gaId) {
    this.gaId = gaId;
    this.debug = process.env.NODE_ENV === 'development';
    this.initialized = false;
  }

  init() {
    ReactGA.initialize(this.gaId, { debug: this.debug });
    this.initialized = true;
  }

  pageview(url) {
    if (!this.initialized) { return; }
    ReactGA.pageview(url);
  }
}



// WEBPACK FOOTER //
// ./src/modules/analytics/analytics.store.js